import React from "react";
import { Button } from "react-bootstrap";
import collaspeSidebarSvg from "./images/collapse-sidebar.svg";
import expandSidebarSvg from "./images/expand-sidebar.svg";

export function CollaspeButton({ collasped, setCollasped }) {
  const onClick = () => setCollasped(!collasped);

  return (
    <footer className="d-flex">
      {collasped ? (
        <aside className="ml-5">
          <Button
            variant="light mr-1 ml-n5 btn-sm position-fixed border shadow"
            style={{ bottom: 8 }}
            onClick={onClick}
          >
            <img src={expandSidebarSvg} width="32" height="32" alt="expand sidebar" />
          </Button>
        </aside>
      ) : (
        <Button
          variant="light ml-auto btn-sm position-fixed border shadow"
          style={{ bottom: 8, left: 230, zIndex: 1 }}
          onClick={onClick}
        >
          <img src={collaspeSidebarSvg} width="32" height="32" alt="collapse sidebar" />
        </Button>
      )}
    </footer>
  );
}
